
































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import {
  DataTable,
  CheckboxValue,
  DataTableData,
  DataTableColumnItem,
  TableSetting,
} from '@/models/dataTable'
import VisibleColumns from '@/abstract/VisibleColumns'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import CheckboxColumn from '@/components/DataTable/Columns/Common/CheckboxColumn.vue'

interface Props {
  tableSetting: TableSetting
  tableData: DataTable
  checkedItems: CheckboxValue[]
  tableDataColumns: DataTableColumnItem[]
  isTable: boolean
}

interface Data {
  recordingInfoId: string
}

interface Methods {
  isChecked: (id: string) => boolean
  getComponentName: (key: string) => string
  initComponent: (key: string) => void
  isOpenInfo: (id: string) => boolean
  toggleRecordInfo: (item: DataTableData) => void
  setRecordQuery: (id: string) => void
}

interface Computed {
  expandRow: boolean
  checkboxValues: CheckboxValue[]
  directory: string
}

export default mixins(WindowResizeListener, VisibleColumns).extend<
  Data,
  Methods,
  Computed,
  Props
>({
  components: {
    PaidLabel,
    CheckboxColumn,
  },
  props: {
    tableSetting: {
      required: true,
    },
    tableData: {
      required: true,
    },
    checkedItems: {
      required: true,
    },
    tableDataColumns: {
      required: true,
    },
    isTable: {
      required: true,
    },
  },
  data() {
    return {
      recordingInfoId: '',
    }
  },
  methods: {
    isChecked(id) {
      return this.checkedItems.includes(id)
    },
    getComponentName(key: string) {
      let newComponentName = `${key}Column`
      newComponentName =
        newComponentName[0].toUpperCase() + newComponentName.slice(1)
      newComponentName = newComponentName.replace('_', '')
      return newComponentName
    },
    initComponent(key: string) {
      Vue.component(this.getComponentName(key), () =>
        import(
          `@/components/DataTable/Columns/${
            this.tableSetting.directory
          }/${this.getComponentName(key)}.vue`
        ),
      )
    },
    isOpenInfo(id) {
      return this.recordingInfoId === id
    },
    toggleRecordInfo(item) {
      this.recordingInfoId = item.id
      this.setRecordQuery(item.id)
    },
    setRecordQuery(id) {
      if (!this.tableSetting.enableRowInfo) {
        return
      }
      const query = Object.assign({}, this.$route.query)
      if (query.record !== id) {
        query.record = id
        this.$router.replace({ query })
      }
    },
  },
  computed: {
    expandRow() {
      return this.$store.getters.getLocalStorage.foxgid_row_view === 'expand'
    },
    checkboxValues: {
      get() {
        return this.checkedItems
      },
      set(value) {
        this.$emit('set-checkbox-values', value)
      },
    },
    directory() {
      return this.tableSetting.directory.toLowerCase()
    },
  },
  created() {
    this.tableData.columns.forEach(elem => {
      this.initComponent(elem.key)
    })
  },
})
